import {ApiService} from './api.service';

/**
 * Clé local storage
 */
const STORAGE_TOKEN_KEY = "jwt-token";

/**
 * AuthenticationService
 */
export const AuthenticationService = {
    /**
     * Supprime le token dans le local storage
     */
    clear() {
        window.localStorage.removeItem(STORAGE_TOKEN_KEY);
    },

    /**
     * Récupération du token depuis le local storage
     */
    getToken() {
        return window.localStorage.getItem(STORAGE_TOKEN_KEY);
    },

    /**
     * Récupération du user
     */
    getUser() {
        return ApiService.get('users/check');
    },

    /**
     * Demande de token
     */
    requestToken(payload) {
        return ApiService.post('request-token', payload);
    },

    /**
     * Enregistrement du token dans le local storage
     */
    storeToken(token) {
        window.localStorage.setItem(STORAGE_TOKEN_KEY, token);
    }
};